import Tool from '@/assets/js/utils.js';
import Cookie from 'js-cookie';
import { mapState } from 'vuex';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import Vue from 'vue';
import router from './router';
export default {
  data() {
    return {
      isHaveJ: false,
      isWindows: true,
      isAndroid: false,
      isHaveMc: false,
      isMac: false,
      byLogin: true,
      // 设置默认值
      info: navigator.userAgent,
      showChrome: false,
      isChrome: true,
      isLinux: false,
      isIos: navigator.userAgent.includes('iPhone') || navigator.userAgent.includes('iOS')
    };
  },
  computed: {
    ...mapState({
      loginInfo: state => state.loginInfo,
      State: state => state,
      BrowserLanguage: state => state.browserLanguage
    })
  },
  watch: {
    BrowserLanguage(val) {
      if (val === 'zh') {
        document.getElementsByTagName('body')[0].classList.add('zhLang');
      } else {
        document.getElementsByTagName('body')[0].classList.remove('zhLang');
      }
    },
    loginInfo(newVal, oldVal) {
      if (newVal) {
        if (!location.host.includes('cn')) {
          if (process.env.NODE_ENV === 'production') {
            const serverErrorsRegex = new RegExp('401 (Unauthorized)', 'mi');
            Sentry.init({
              Vue,
              dsn: 'https://8f775aaa6e6541c1b81bbfd8d0ceffd3@o982456.ingest.sentry.io/5938310',
              beforeSend(event, hint) {
                const exception = hint.originalException;
                if (exception && exception.__sentry_ignore__) {
                  return null;
                }
                return event;
              },
              integrations: [new Integrations.BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                tracingOrigins: ['localhost', 'local@tvunetworks.com', /^\//]
              })],
              ignoreErrors: [serverErrorsRegex, /Request canceled/],
              tracesSampleRate: 0.01,
              logErrors: true,
              environment: this.State.config.env
            });
            Sentry.setUser({
              email: newVal.email
            });
          }
        }
      }
    }
  },
  async created() {
    this.isHaveJ = window.location.href.includes('join_id');
    this.isWindows = navigator.userAgent.includes('Windows');
    this.isHaveMc = window.location.href.includes('Mc');
    this.isAndroid = navigator.userAgent.includes('Android');
    this.byLogin = window.location.href.includes('byLogin');
    this.isMac = /Macintosh|Mac OS X/i.test(navigator.userAgent);
    this.isChrome = /Chrome/i.test(navigator.userAgent);
    this.isLinux = /Linux/i.test(navigator.userAgent);
    Bus.$on('createWs', v => {
      this.createdWebsocket(v);
    });
    this.showChrome = !sessionStorage.getItem('isSetChromeTips');
    // HubSpot Embed Code. 中国区不加载，全球区加载
    if (!location.host.includes('cn')) {
      Tool.dynamicLoadJs('//js.hs-scripts.com/19963008.js', null, 'hs-script-loader');
    }
  },
  methods: {
    closeChromeTips() {
      this.showChrome = false;
      sessionStorage.setItem('isSetChromeTips', true);
    },
    createdWebsocket(addressInfo) {
      const taskId = Tool.return32Str();
      const partyCode = addressInfo.partyCode;
      const globalControlId = addressInfo.globalControlId ? addressInfo.globalControlId : '';
      if (!partyCode && !globalControlId) {
        return;
      }
      if (globalControlId) {
        if (this.State.pageSerBusRequestWs[globalControlId]) return;
      } else {
        if (this.State.pageSerBusRequestWs[partyCode]) return;
      }
      if (!addressInfo.urlInfo) return;
      const url = 'wss://' + addressInfo.urlInfo.ccWebsocket + '/pageSerBusRequest?taskId=' + taskId + '&notCheckUser=true' + '&businessId=' + globalControlId + this.State.loginInfo.id + ':' + partyCode;
      this.socket = Tool.createWs(url);
      if (globalControlId) {
        this.State.pageSerBusRequestWs[globalControlId] = this.socket;
      } else {
        this.State.pageSerBusRequestWs[partyCode] = this.socket;
      }
      Bus.$emit('pageSerBusCallback', {
        socket: this.socket,
        partyCode
      });
    }
  },
  mounted() {
    this.$nextTick(() => {
      const language = Cookie.get('userLanguage') || navigator.language.slice(0, 2);
      this.State.browserLanguage = language;
      if (language === 'zh') {
        document.getElementsByTagName('body')[0].classList.add('zhLang');
      } else {
        document.getElementsByTagName('body')[0].classList.remove('zhLang');
      }
    });
  }
};